import type { WindowDescriptor } from '@krp/client-runtime'

import type { OneCUiState } from '../../state'

/** Окно «Чеки 1С» (RP-FB12): чеки ККМ и возвраты одной базы. `:rid` в адресе — чеки двух баз не смешиваются. */
export const ONEC_RECEIPT_WINDOWS = {
  receipts: 'onec.receipts',
  /** «Статистика по продажам» базы 1С: сводки поверх тех же частей, что и «Чеки»; отдельный пункт меню. */
  salesStatistics: 'onec.sales-statistics',
  receipt: 'onec.cash-receipt',
} as const

export const receiptsWindows: readonly WindowDescriptor<OneCUiState>[] = [
  // Чек — окно поверх экрана (`?w=`): открывается из таблицы чеков и статистики магазина, закрыли — снова виден список.
  { kind: ONEC_RECEIPT_WINDOWS.receipt, scope: 'resource', paths: ['/onec/:rid/receipts/:kind/:key'], label: 'Чек 1С', size: 'lg', section: { id: 'receipts' } },
  {
    kind: ONEC_RECEIPT_WINDOWS.receipts,
    scope: 'resource',
    paths: ['/onec/:rid/receipts'],
    label: 'Чеки 1С',
  },
  {
    kind: ONEC_RECEIPT_WINDOWS.salesStatistics,
    scope: 'resource',
    paths: ['/onec/:rid/sales-statistics'],
    label: 'Статистика по продажам 1С',
  },
]
